var config = {
    api: {
        local: 'https://api.stg.atlassian.com/metal/ingest',
        dev: 'https://api.stg.atlassian.com/metal/ingest',
        staging: 'https://api.stg.atlassian.com/metal/ingest',
        prod: 'https://api.atlassian.com/metal/ingest',
    },
};
export default config;
